import { useEffect, useState } from 'react'
import { WbsItemBasic } from '../../../../lib/functions/wbsItem'
import { loadWbsItemBasic, peekCachedWbsItemBasic } from '../wbsItemBasicCache'

export type WbsItemBasicLookup =
  | { status: 'loading' }
  | { status: 'resolved'; basic: WbsItemBasic }
  | { status: 'unavailable' }

const toLookup = (
  basic: WbsItemBasic | null | undefined
): WbsItemBasicLookup => {
  if (basic === undefined) {
    return { status: 'loading' }
  }
  return basic ? { status: 'resolved', basic } : { status: 'unavailable' }
}

/**
 * WBS アイテムのコードから WbsItemBasic を取得する（キャッシュ・重複排除は wbsItemBasicCache 側）。
 *
 * 取得できない（404 = モデルの幻覚 / 403 = 参照権限なし）場合も unavailable を返すだけで、
 * ここでは例外を投げない・通知も出さない。呼び出し側（WbsItemLinkChip）がチップをやめて
 * 本文のプレーンテキストに切り替える判断材料として使う。
 */
export const useWbsItemBasicByCode = (code: string): WbsItemBasicLookup => {
  const [lookup, setLookup] = useState<WbsItemBasicLookup>(() =>
    toLookup(peekCachedWbsItemBasic(code))
  )

  useEffect(() => {
    let cancelled = false
    const cached = peekCachedWbsItemBasic(code)
    if (cached !== undefined) {
      setLookup(toLookup(cached))
      return
    }
    setLookup({ status: 'loading' })
    loadWbsItemBasic(code).then(basic => {
      if (!cancelled) {
        setLookup(toLookup(basic))
      }
    })
    return () => {
      cancelled = true
    }
  }, [code])

  return lookup
}
